import { useSignal } from '@preact/signals';
import { PRESETS } from '../sim/presets.ts';
import { applyPreset } from '../state/store.ts';

/** Ready-made weather histories, name + description, applied on click. Shown in both simple and
 * advanced mode. The clicked preset is highlighted locally (there's no cheap way to tell whether
 * the current conditions still match a preset once anything's been edited). */
export function PresetPicker() {
  const activeId = useSignal<string | null>(null);

  return (
    <section class="panel-section">
      <h2>Scenario preset</h2>
      <div class="preset-list">
        {PRESETS.map((p) => (
          <button
            key={p.id}
            type="button"
            class={'preset-item' + (activeId.value === p.id ? ' active' : '')}
            onClick={() => {
              activeId.value = p.id;
              applyPreset(p);
            }}
          >
            <span class="preset-name">{p.name}</span>
            <span class="preset-description">{p.description}</span>
          </button>
        ))}
      </div>
    </section>
  );
}
